import { useFormik } from "formik";
import { useEffect } from "react";

// Internal Imports
import EditTextForm from "../../../common/components/EditTextForm/EditTextForm";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import Paint from "../../../common/components/Paint/Paint";
import SelectBox from "../../../common/components/SelectBox/SelectBox";
import { COLORS } from "../../../common/constants/colors";
import { fakeUser, validateEmail } from "../../../common/constants/Utilities";
import GroupRow from "../../../common/components/GroupRow/GroupRow";
import globalStyle from "../../../common/styles/globalStyle.module.css";
import { Mode } from "../../../common/types/AllTypes";
import { useAuth } from "../../../contexts/auth";
import { useForm } from "../../../contexts/form";
import useListSexType from "../../../hooks/useListSexType";

interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    setCanGoBack: React.Dispatch<React.SetStateAction<boolean>>;
    mode: Mode;
}

const StepTwo = ({ setCanGoNext, setCanGoBack, mode }: Props) => {

    // States
    const { user } = useAuth();
    const { loadingTypeSex, listTypeSex } = useListSexType();
    const { setUserInformationForm, userInformationForm } = useForm();

    // Methods
    const validations = (values: any) => {
        const errors: any = {};

        if (!values.primerNombre) {
            errors.primerNombre = 'Requerido';
        }

        if (!values.primerApellido) {
            errors.primerApellido = 'Requerido';
        }

        if (!values.sexoTipo) {
            errors.sexoTipo = 'Requerido';
        }

        if (!!values.cedula) {
            if (values.cedula.toString().length > 11 || values.cedula.toString().length < 11) {
                errors.cedula = 'Debe tener 11 dígitos';
            }
        }

        if (validateEmail(values.correo)) {
            errors.correo = 'Correo incorrecto';
        }

        return errors;
    }

    // Form
    const UserForm = useFormik({
        initialValues: { primerNombre: "", segundoNombre: "", primerApellido: "", segundoApellido: "", correo: "", cedula: "", sexoTipo: "" },
        validate: validations,
        onSubmit: (values: any) => console.log(values),
    });

    // Effects
    useEffect(() => {
        UserForm.validateForm().then((response) => {
            if (!!userInformationForm) {
                UserForm.setValues({
                    primerNombre: userInformationForm.primerNombre,
                    segundoNombre: !!userInformationForm.segundoNombre ? userInformationForm.segundoNombre : "",
                    primerApellido: userInformationForm.primerApellido,
                    segundoApellido: !!userInformationForm.segundoApellido ? userInformationForm.segundoApellido : "",
                    correo: !!userInformationForm.correo ? userInformationForm.correo : "",
                    cedula: !!userInformationForm.cedula ? userInformationForm.cedula : "",
                    sexoTipo: userInformationForm.sexoTipo?.toString() || ""
                });
            }

            if (JSON.stringify(response) == '{}') {
                setCanGoNext(true);
            } else {
                setCanGoNext(false);
            }
        });
        setCanGoBack(true);
    }, [])


    useEffect(() => {
        if (mode === 'Update' || !!userInformationForm) {
            setUserInformationForm({
                ...userInformationForm!,
                primerNombre: UserForm.values.primerNombre,
                segundoNombre: UserForm.values.segundoNombre,
                primerApellido: UserForm.values.primerApellido,
                segundoApellido: UserForm.values.segundoApellido,
                correo: UserForm.values.correo,
                cedula: UserForm.values.cedula,
                sexoTipo: parseInt(UserForm.values.sexoTipo) || null,

                //
                usuarioModificoID: user?.usuarioID
                //
            });
        } else {
            setUserInformationForm({
                ...fakeUser,
                primerNombre: UserForm.values.primerNombre,
                segundoNombre: UserForm.values.segundoNombre,
                primerApellido: UserForm.values.primerApellido,
                segundoApellido: UserForm.values.segundoApellido,
                correo: UserForm.values.correo,
                cedula: UserForm.values.cedula,
                sexoTipo: parseInt(UserForm.values.sexoTipo) || null,
            });
        }
        if (JSON.stringify(UserForm.errors) == '{}') {
            setCanGoNext(true);
        } else {
            setCanGoNext(false);
        }
    }, [UserForm.values, UserForm.isValid]);


    return (
        <div style={{ marginTop: 20 }}>
            <GroupRow>
                <MarginInput width="45%">
                    <label>Primer Nombre:</label>
                    <EditTextForm
                        value={UserForm.values.primerNombre}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"primerNombre"}
                        placeholder={"Primer Nombre"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.primerNombre && UserForm.errors.primerNombre}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Segundo Nombre:</label>
                    <EditTextForm
                        value={UserForm.values.segundoNombre}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"segundoNombre"}
                        placeholder={"Segundo Nombre"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.segundoNombre && UserForm.errors.segundoNombre}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="45%">
                    <label>Primer Apellido:</label>
                    <EditTextForm
                        value={UserForm.values.primerApellido}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"primerApellido"}
                        placeholder={"Primer Apellido"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.primerApellido && UserForm.errors.primerApellido}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Segundo Apellido:</label>
                    <EditTextForm
                        value={UserForm.values.segundoApellido}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"segundoApellido"}
                        placeholder={"Segundo Apellido"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.segundoApellido && UserForm.errors.segundoApellido}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="100%">
                    <label>Correo:</label>
                    <EditTextForm
                        value={UserForm.values.correo}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"correo"}
                        placeholder={"Correo"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.correo && UserForm.errors.correo}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="45%">
                    <label>Cédula:</label>
                    <EditTextForm
                        value={UserForm.values.cedula}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"cedula"}
                        placeholder={"Cédula"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'number'}
                        decimalOrInteger={'integer'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.cedula && UserForm.errors.cedula}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Sexo:</label>
                    <SelectBox
                        value={UserForm.values.sexoTipo}
                        defaultValue={userInformationForm?.sexoTipo}
                        placeholder={"Sexo"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingTypeSex}
                        onChange={(value: string) => UserForm.setFieldValue('sexoTipo', value.toString())}
                        options={listTypeSex.map(sex => ({ key: sex.value, value: sex.key.toString(), text: sex.value }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.sexoTipo && UserForm.errors.sexoTipo}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>
        </div>
    );
}

export default StepTwo;